import React from "react";

import { EvaluationList } from "@components/Evaluation";

export default function EvaluationIndex() {
  return <EvaluationList />;
}
